import { Join } from './join';
import { OutputSelector } from './output-selector.interface';
import { SelectFirst } from './select-first';
import { SelectLast } from './select-last';


/**
 * Converts string input to respective output selector.
 */
export class OutputSelectorBuilder {
	private constructor() { }

	public static build(type: string): OutputSelector {
		switch (type) {
			case 'selectLast':
				return new SelectLast();
			case 'join':
				return new Join();
			case 'selectFirst':
			default:
				return new SelectFirst();
		}
	}
}
